// 账户与身份：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 公共基础词条
export const base = Object.freeze({
  "account.quickEntry": "快捷入口",
  "account.featuredTrade": "精選交易",
  "account.userOverview": "用戶與資產概覽",
  "account.assetsOverview": "資產概覽",
  "account.defaultReviewLevel": "好評等級1",
  "account.avatar": "用戶頭像",
  "account.applyBroker": "申請談判人",
  "account.loggedIn": "已登入",
  "account.balance": "賬戶餘額",
  "account.withdraw": "去提現",
  "account.withdrawable": "可提現",
  "account.frozen": "凍結中",
  "account.points": "積分",
  "account.coins": "金幣",
  "account.tradeOrders": "交易訂單",
  "account.goodsCenter": "商品中心",
  "account.messages": "訊息管理",
  "account.goodsLibrary": "商品庫",
  "account.suppliers": "供應商管理",
  "account.logoutCurrent": "退出當前賬號",
  "account.comingSoon": "即將開放",
});

// 账户设置
export const settings = Object.freeze({
  "accountSettings.save": "儲存",
  "accountSettings.reset": "重置",
  "accountSettings.security.title": "安全設置",
  "accountSettings.security.oldPassword": "原密碼",
  "accountSettings.security.enterOldPassword": "請輸入原密碼",
  "accountSettings.security.newPassword": "新密碼",
  "accountSettings.security.enterNewPassword": "請輸入新密碼",
  "accountSettings.security.confirmPassword": "確認密碼",
  "accountSettings.security.enterConfirmPassword": "請再次輸入新密碼",
  "accountSettings.security.mobileVerification": "手機驗證",
  "accountSettings.security.enterCode": "請輸入驗證碼",
  "accountSettings.security.resendAfter": "{seconds}秒後重發",
  "accountSettings.security.getCode": "獲取驗證碼",
  "accountSettings.security.tipsTitle": "安全提示",
  "accountSettings.security.tipLength": "密碼長度至少8位，包含字母和數字",
  "accountSettings.security.tipComplexity": "不要使用過於簡單的密碼",
  "accountSettings.security.tipRotation": "定期更換密碼，保障賬號安全",
  "accountSettings.security.tipPublic": "不要在公共場合輸入密碼",
  "accountSettings.security.passwordMismatch": "兩次輸入的密碼不一致",
  "accountSettings.security.minLength": "密碼長度至少8位",
  "accountSettings.security.codeSent": "驗證碼已發送",
  "accountSettings.security.passwordChanged": "密碼修改成功",
  "accountSettings.personal.title": "個人資料",
  "accountSettings.personal.avatar": "頭像",
  "accountSettings.personal.nickname": "暱稱",
  "accountSettings.personal.enterNickname": "請輸入暱稱",
  "accountSettings.personal.mobile": "流動電話號碼",
  "accountSettings.personal.enterMobile": "請輸入流動電話號碼",
  "accountSettings.personal.invalidMobile": "請輸入正確的流動電話號碼",
  "accountSettings.personal.email": "電郵地址",
  "accountSettings.personal.enterEmail": "請輸入電郵地址",
  "accountSettings.personal.gender": "性別",
  "accountSettings.personal.male": "男",
  "accountSettings.personal.female": "女",
  "accountSettings.personal.unspecified": "保密",
  "accountSettings.personal.birthday": "生日",
  "accountSettings.personal.selectDate": "選擇日期",
  "accountSettings.personal.address": "地址",
  "accountSettings.personal.enterAddress": "請輸入地址",
  "accountSettings.personal.avatarFormat": "上傳頭像圖片只能是 JPG/PNG 格式!",
  "accountSettings.personal.avatarSize": "上傳頭像圖片大小不能超過 2MB!",
  "accountSettings.personal.avatarUploaded": "頭像上傳成功",
  "accountSettings.personal.saved": "儲存成功",
  "accountSettings.verification.title": "賬號認證",
  "accountSettings.verification.realNameTitle": "實名認證",
  "accountSettings.verification.verified": "已認證",
  "accountSettings.verification.unverified": "未認證",
  "accountSettings.verification.realName": "真實姓名",
  "accountSettings.verification.enterRealName": "請輸入真實姓名",
  "accountSettings.verification.idCard": "身份證號",
  "accountSettings.verification.enterIdCard": "請輸入身份證號",
  "accountSettings.verification.invalidIdCard": "請輸入正確的身份證號",
  "accountSettings.verification.idCardFront": "身份證正面",
  "accountSettings.verification.uploadIdCardFront": "上傳身份證正面",
  "accountSettings.verification.idCardBack": "身份證反面",
  "accountSettings.verification.uploadIdCardBack": "上傳身份證反面",
  "accountSettings.verification.submit": "提交認證",
  "accountSettings.verification.companyTitle": "企業認證",
  "accountSettings.verification.companyName": "企業名稱",
  "accountSettings.verification.enterCompanyName": "請輸入企業名稱",
  "accountSettings.verification.businessLicense": "營業執照",
  "accountSettings.verification.uploadBusinessLicense": "上傳營業執照",
  "accountSettings.verification.loading": "認證狀態載入中...",
  "accountSettings.verification.realNameSubmitted": "實名認證提交成功",
  "accountSettings.verification.companySubmitted": "企業認證提交成功",
});

// 登录注册
export const auth = Object.freeze({
  "auth.supportedSmsRegions":
    "短訊目前支援中國大陸和中國香港，其他地區請使用電郵登入",
  "auth.invalidHongKongMobile": "請輸入正確的中國香港手機號碼（8位數字）",

  "auth.codeLoginMethods": "驗證碼登入方式",
  "auth.emailLogin": "電郵登入",
  "auth.emailCodeLogin": "電郵驗證碼登入",
  "auth.codeLogin": "驗證碼登入",
  "auth.switchCodeLogin": "切換至驗證碼登入",
  "auth.returnCodeLogin": "返回驗證碼登入",
  "auth.emailAddress": "電郵地址",
  "auth.enterEmailAddress": "請輸入電郵地址",
  "auth.emailCode": "電郵驗證碼",
  "auth.defaultMobileVerification": "預設手機號碼驗證",
  "auth.defaultEmailVerification": "預設電郵驗證",
  "auth.mainlandSmsUseEmail":
    "目前短訊通道只支援中國內地手機號碼，請使用電郵登入",
  "auth.verificationCodeSendFailed": "驗證碼發送失敗",
  "auth.emailVerificationCodeSendFailed": "電郵驗證碼發送失敗",
  "auth.emailVerificationCodeSent": "電郵驗證碼已發送",
  "auth.codeLoginPasswordResetHint": "請先使用驗證碼登入，再到個人中心更改密碼",
  "auth.emailCodeSendFailed": "電郵地址驗證碼發送失敗，請稍後重試",
  "auth.emailCodeSent": "電郵地址驗證碼發送成功",
  "auth.brandScene": "Xsou 供應鏈場景",
  "auth.brandHeadlineFirst": "讓每一次供需連接",
  "auth.brandHeadlineSecond": "更快、更準、更可靠",
  "auth.brandService": "卓越服務",
  "auth.brandCreation": "持續創造",
  "auth.brandCollaboration": "協作共贏",
  "auth.brandValue": "價值共享",
  "auth.close": "關閉",
  "auth.accountActions": "賬號操作",
  "auth.accountType": "賬號類型",
  "auth.login": "登入",
  "auth.register": "註冊",
  "auth.mobile": "流動電話號碼",
  "auth.mobileOrEmail": "流動電話號碼 / 電郵地址",
  "auth.areaCode": "國家或地區區號",
  "auth.registerAreaCode": "註冊流動電話號碼國家或地區區號",
  "auth.areaMainland": "中國大陸 +86",
  "auth.areaHongKong": "中國香港 +852",
  "auth.areaMacau": "中國澳門 +853",
  "auth.areaTaiwan": "中國台灣 +886",
  "auth.areaNorthAmerica": "美國/加拿大 +1",
  "auth.areaSingapore": "新加坡 +65",
  "auth.enterMobile": "請輸入流動電話號碼",
  "auth.smsCode": "短訊驗證碼",
  "auth.enterCode": "請輸入驗證碼",
  "auth.resendAfter": "{seconds}s 後重發",
  "auth.getCode": "獲取驗證碼",
  "auth.loggingIn": "登入中…",
  "auth.noAccount": "還沒有賬號？",
  "auth.registerNow": "立即註冊",
  "auth.passwordLogin": "密碼登入",
  "auth.switchPasswordLogin": "切換到密碼登入",
  "auth.wechatLogin": "微信登入",
  "auth.switchWechatLogin": "切換到微信登入",
  "auth.password": "密碼",
  "auth.forgotPassword": "忘記密碼",
  "auth.enterMobileOrEmail": "請輸入流動電話號碼或電郵地址",
  "auth.enterLoginPassword": "請輸入登入密碼",
  "auth.hidePassword": "隱藏密碼",
  "auth.showPassword": "顯示密碼",
  "auth.smsLogin": "短訊登入",
  "auth.switchSmsLogin": "切換到短訊登入",
  "auth.wechatLoginQr": "微信登入二維碼",
  "auth.wechatRegisterQr": "微信註冊二維碼",
  "auth.qrLoading": "二維碼載入中",
  "auth.qrExpired": "二維碼已失效",
  "auth.refreshQr": "點擊刷新",
  "auth.scanWechatToLogin": "使用微信掃碼登入",
  "auth.scanWechatLoginHint": "打開微信掃一掃，確認後即可登入",
  "auth.returnSmsLogin": "返回短訊驗證碼登入",
  "auth.personalAccount": "個人賬號",
  "auth.companyAccount": "企業賬號",
  "auth.mainland": "中國大陸",
  "auth.overseas": "港澳台及海外",
  "auth.defaultMobileRegistration": "預設流動電話號碼註冊",
  "auth.verifyByMobile": "使用流動電話號碼驗證",
  "auth.defaultEmailRegistration": "預設電郵地址註冊",
  "auth.verifyByEmail": "使用電郵地址驗證",
  "auth.scanWechatToRegister": "使用微信掃碼註冊",
  "auth.scanWechatRegisterHint": "打開微信掃一掃，確認後即可完成註冊並登入",
  "auth.returnMobileRegistration": "返回流動電話號碼註冊",
  "auth.returnEmailRegistration": "返回電郵地址註冊",
  "auth.mainlandMobile": "中國大陸流動電話號碼",
  "auth.overseasMobile": "港澳台及海外流動電話號碼",
  "auth.email": "常用電郵地址",
  "auth.enterEmail": "請輸入常用電郵地址",
  "auth.code": "驗證碼",
  "auth.enterFourDigitCode": "請輸入4位驗證碼",
  "auth.loginPassword": "登入密碼",
  "auth.enterPasswordLength": "請輸入 8–20 位密碼",
  "auth.companyName": "企業名稱",
  "auth.enterCompanyName": "請輸入企業全稱",
  "auth.contactName": "聯絡人姓名",
  "auth.enterContactName": "請輸入聯絡人姓名",
  "auth.registering": "註冊中…",
  "auth.finishRegistration": "完成註冊",
  "auth.haveAccount": "已有賬號？",
  "auth.loginNow": "立即登入",
  "auth.wechatRegistration": "微信註冊",
  "auth.registrationSuccess": "註冊成功",
  "auth.companyAccountCreated": "企業賬號已創建",
  "auth.personalAccountCreated": "個人賬號已創建",
  "auth.registrationCompleted": "{context}註冊已完成。",
  "auth.sentenceSeparator": "",
  "auth.companyCertificationHint": "繼續認證後可使用完整企業功能。",
  "auth.enterXsouHint": "現在可以直接進入 Xsou。",
  "auth.continueCompanyCertification": "繼續企業認證",
  "auth.skipAndEnter": "暫時跳過，先進入 Xsou",
  "auth.enterXsou": "進入 Xsou",
  "auth.agreementPrefix": "我已閲讀並同意",
  "auth.userAgreement": "《用戶協議》",
  "auth.agreementConjunction": "和",
  "auth.privacyPolicy": "《隱私政策》",
  "auth.emailRegistration": "電郵地址註冊",
  "auth.mobileRegistration": "流動電話號碼註冊",
  "auth.agreementRequired":
    "登入或註冊前，請先閲讀並同意《用戶協議》和《隱私政策》。點擊確定將為您自動勾選。",
  "auth.loginAgreementRequired":
    "登入前請閲讀並同意《用戶協議》和《隱私政策》。確認後將自動勾選並繼續登入。",
  "auth.agreementTitle": "用戶協議與隱私政策",
  "auth.confirm": "確定",
  "auth.cancel": "取消",
  "auth.agreeAndLogin": "同意並登入",
  "auth.internationalSmsUnavailable": "國際短訊通道待後端介面接入",
  "auth.invalidMainlandMobile": "請輸入正確的中國大陸流動電話號碼",
  "auth.smsSent": "短訊驗證碼已發送",
  "auth.internationalLoginUnavailable": "國際流動電話號碼登入介面待接入",
  "auth.invalidMobile": "請輸入正確的流動電話號碼",
  "auth.invalidFourDigitCode": "請輸入4位數字驗證碼",
  "auth.accountAndPasswordRequired": "請輸入賬號和密碼",
  "auth.forgotPasswordUnavailable": "忘記密碼流程待後端介面接入",
  "auth.qrFetchFailed": "二維碼獲取失敗",
  "auth.wechatRegistrationSuccess": "微信註冊成功",
  "auth.invalidEmail": "請輸入正確的電郵地址",
  "auth.emailCodeUnavailable": "電郵地址驗證碼介面待接入",
  "auth.invalidOverseasMobile": "請輸入6-20位數字流動電話號碼",
  "auth.invalidPasswordLength": "請輸入 8–20 位登入密碼",
  "auth.companyNameRequired": "請輸入企業名稱",
  "auth.contactNameRequired": "請輸入聯絡人姓名",
  "auth.registrationExpired": "註冊資料已失效，請重新註冊",
  "auth.registrationWelcome": "註冊成功，歡迎使用 Xsou",
  "auth.loginSuccess": "登入成功",
  "auth.requestFailed": "請求失敗，請稍後重試",
});

// 移动登录
export const mobileLogin = Object.freeze({
  "mobileLogin.heroBackground": "登入頁背景",
  "mobileLogin.back": "返回",
  "mobileLogin.loginHint": "登入提示",
  "mobileLogin.welcome": "歡迎登入",
  "mobileLogin.heroLineOne": "連接真實供需，",
  "mobileLogin.heroLineTwo": "讓晶片交易更高效",
  "mobileLogin.accountAction": "賬號操作",
  "mobileLogin.login": "登入",
  "mobileLogin.register": "註冊",
  "mobileLogin.passwordLogin": "密碼登入",
  "mobileLogin.smsLogin": "短訊登入",
  "mobileLogin.accountPlaceholder": "請輸入流動電話號碼或電郵地址",
  "mobileLogin.passwordPlaceholder": "請輸入登入密碼",
  "mobileLogin.forgotPassword": "忘記密碼",
  "mobileLogin.loggingIn": "登入中…",
  "mobileLogin.mobilePlaceholder": "請輸入流動電話號碼",
  "mobileLogin.codePlaceholder": "請輸入驗證碼",
  "mobileLogin.resendCountdown": "{seconds}s 後重發",
  "mobileLogin.getCode": "獲取驗證碼",
  "mobileLogin.noAccount": "還沒有賬號？",
  "mobileLogin.registerNow": "立即註冊",
  "mobileLogin.otherLoginMethods": "其他登入方式",
  "mobileLogin.wechatLogin": "微信登入",
  "mobileLogin.registerType": "註冊類型",
  "mobileLogin.personalAccount": "個人賬號",
  "mobileLogin.companyAccount": "企業賬號",
  "mobileLogin.registerRegion": "註冊地區",
  "mobileLogin.mainland": "中國大陸",
  "mobileLogin.defaultMobileRegister": "預設流動電話號碼註冊",
  "mobileLogin.mobileVerification": "使用流動電話號碼驗證",
  "mobileLogin.overseas": "港澳台及海外",
  "mobileLogin.defaultEmailRegister": "預設電郵地址註冊",
  "mobileLogin.emailVerification": "使用電郵地址驗證",
  "mobileLogin.mainlandMobile": "中國大陸流動電話號碼",
  "mobileLogin.overseasMobile": "港澳台及海外流動電話號碼",
  "mobileLogin.commonEmail": "常用電郵地址",
  "mobileLogin.mainlandCode": "中國大陸 +86",
  "mobileLogin.hongKongCode": "中國香港 +852",
  "mobileLogin.macaoCode": "中國澳門 +853",
  "mobileLogin.taiwanCode": "中國台灣 +886",
  "mobileLogin.usCanadaCode": "美國/加拿大 +1",
  "mobileLogin.singaporeCode": "新加坡 +65",
  "mobileLogin.registrationAreaCode": "註冊流動電話號碼國家或地區區號",
  "mobileLogin.areaCode": "國家或地區區號",
  "mobileLogin.emailPlaceholder": "請輸入常用電郵地址",
  "mobileLogin.verificationCode": "驗證碼",
  "mobileLogin.fourDigitCodePlaceholder": "請輸入4位驗證碼",
  "mobileLogin.loginPassword": "登入密碼",
  "mobileLogin.newPasswordPlaceholder": "請輸入 8–20 位密碼",
  "mobileLogin.companyName": "企業名稱",
  "mobileLogin.companyNamePlaceholder": "請輸入企業全稱",
  "mobileLogin.contactName": "聯絡人姓名",
  "mobileLogin.contactNamePlaceholder": "請輸入聯絡人姓名",
  "mobileLogin.submitting": "提交中…",
  "mobileLogin.completeRegistration": "完成註冊",
  "mobileLogin.haveAccount": "已有賬號？",
  "mobileLogin.loginNow": "立即登入",
  "mobileLogin.otherRegisterMethods": "其他註冊方式",
  "mobileLogin.emailRegister": "電郵地址註冊",
  "mobileLogin.mobileRegister": "流動電話號碼註冊",
  "mobileLogin.wechatRegister": "微信註冊",
  "mobileLogin.readAndAgree": "我已閲讀並同意",
  "mobileLogin.userAgreement": "《用戶協議》",
  "mobileLogin.and": "和",
  "mobileLogin.privacyPolicy": "《隱私政策》",
  "mobileLogin.internationalSmsUnavailable": "國際短訊通道待後端介面接入",
  "mobileLogin.invalidMainlandMobile": "請輸入正確的中國大陸流動電話號碼",
  "mobileLogin.smsCodeSent": "短訊驗證碼已發送",
  "mobileLogin.internationalLoginUnavailable": "國際流動電話號碼登入介面待接入",
  "mobileLogin.invalidMobile": "請輸入正確的流動電話號碼",
  "mobileLogin.invalidSmsCode": "請輸入正確的短訊驗證碼",
  "mobileLogin.accountPasswordRequired": "請輸入賬號和密碼",
  "mobileLogin.invalidEmail": "請輸入正確的電郵地址",
  "mobileLogin.emailCodeUnavailable": "電郵地址驗證碼介面待接入",
  "mobileLogin.invalidOverseasMobile": "請輸入6-20位數字流動電話號碼",
  "mobileLogin.invalidFourDigitCode": "請輸入4位數字驗證碼",
  "mobileLogin.invalidPasswordLength": "請輸入 8–20 位登入密碼",
  "mobileLogin.companyNameRequired": "請輸入企業名稱",
  "mobileLogin.contactNameRequired": "請輸入聯絡人姓名",
  "mobileLogin.registrationSucceeded": "註冊成功",
  "mobileLogin.requestError": "請求異常！",
  "mobileLogin.loginSucceeded": "登入成功",
  "mobileLogin.forgotPasswordHint":
    "請先使用短訊登入，登入後在個人中心修改密碼",
  "mobileLogin.agreementRequired": "請先閲讀並同意用戶協議與隱私政策",
  "mobileLogin.agreementTitle": "用戶協議與隱私政策",
  "mobileLogin.agreementMessage":
    "登入前請閲讀並同意《用戶協議》和《隱私政策》。確認後將自動勾選並繼續登入。",
  "mobileLogin.agreeAndLogin": "同意並登入",
  "mobileLogin.cancel": "取消",
  "mobileLogin.authorizationMissing": "授權參數缺失，請重新授權",
  "mobileLogin.requestFailedRetry": "請求失敗，請稍後重試",
});

// 移动实名认证
export const mobileRealname = Object.freeze({
  "realname.title": "實名認證",
  "realname.securityTitle": "資料安全保障",
  "realname.securityDescription":
    "認證資料僅用於身份核驗，平台將嚴格保護您的隱私安全。",
  "realname.documents": "證件材料",
  "realname.idFront": "身份證人像面",
  "realname.uploadIdFront": "上傳身份證人像面",
  "realname.idBack": "身份證國徽面",
  "realname.uploadIdBack": "上傳身份證國徽面",
  "realname.basicInformation": "基本資料",
  "realname.matchDocumentHint": "請填寫與本人證件一致的資料",
  "realname.name": "姓名",
  "realname.namePlaceholder": "請輸入證件上的姓名",
  "realname.nameInvalid": "姓名不能為空、不能包含數字，且不能超過100個字符",
  "realname.idNumber": "身份證號",
  "realname.idNumberPlaceholder": "請輸入18位身份證號碼",
  "realname.idNumberInvalid": "請輸入正確的身份證號",
  "realname.mobile": "流動電話號碼",
  "realname.mobilePlaceholder": "請輸入本人流動電話號碼",
  "realname.mobileRequired": "請填寫流動電話號碼",
  "realname.smsCode": "短訊驗證碼",
  "realname.smsCodePlaceholder": "請輸入驗證碼",
  "realname.smsCodeRequired": "請填寫短訊驗證碼",
  "realname.useMobileAbove": "將使用上方流動電話號碼",
  "realname.wechatPlaceholder": "請輸入常用微信號",
  "realname.wechat": "微信號",
  "realname.sameAsMobile": "同流動電話號碼",
  "realname.submitting": "提交中...",
  "realname.submit": "提交認證",
  "realname.getCode": "獲取驗證碼",
  "realname.resendAfter": "{seconds}秒後重發",
  "realname.wechatRequired": "請填寫微信號或選中同流動電話號碼",
  "realname.mobileInvalid": "請輸入正確的流動電話號碼",
  "realname.smsSent": "短訊已發送,注意查收",
  "realname.smsFailed": "發送失敗，請稍後重試",
  "realname.completeRequired": "請完善必填資料",
  "realname.smsCodeInvalid": "請輸入正確的短訊驗證碼",
  "realname.success": "認證成功!",
  "realname.submitFailed": "提交失敗",
  "realname.submitRetry": "提交失敗，請稍後重試",
});

// 移动钱包
export const mobileWallet = Object.freeze({
  "wallet.title": "我的錢包",
  "wallet.loading": "錢包數據載入中",
  "wallet.accountAssets": "賬戶資產",
  "wallet.accountBalance": "賬戶餘額",
  "wallet.goToWithdraw": "前往提現",
  "wallet.withdraw": "去提現",
  "wallet.viewDetails": "查看明細",
  "wallet.pointsDetails": "積分明細",
  "wallet.pointsDescription": "百科審核獎勵及積分收支記錄",
  "wallet.recordCount": "{count} 條",
  "wallet.pointsLoading": "積分明細載入中",
  "wallet.loadingShort": "載入中",
  "wallet.pointsChange": "積分變動",
  "wallet.balanceAfter": "餘額 {balance}",
  "wallet.noPointsRecords": "暫無積分明細",
  "wallet.rewardDetails": "獎勵明細",
  "wallet.rewardDescription": "交易成功獎勵及提現進度",
  "wallet.transactionReward": "交易成功獎勵",
  "wallet.identityUnknown": "未標註身份",
  "wallet.loadFailed": "錢包數據載入失敗",
  "wallet.noRewardRecords": "暫無獎勵明細",
  "wallet.reload": "重新載入",
  "wallet.withdrawableBalance": "可提現金額",
  "wallet.frozenBalance": "凍結金額",
  "wallet.points": "積分",
  "wallet.coins": "金幣",
  "wallet.partialLoadFailed": "部分錢包數據載入失敗，請稍後重試",
  "wallet.pending": "待到賬",
  "wallet.received": "已到賬",
  "wallet.processing": "處理中",
});

// 企业资料
export const company = Object.freeze({
  "companyInfo.companyInformation": "公司資料",
  "companyInfo.shippingInformation": "收貨資料",
  "companyInfo.contacts": "聯絡人",
  "companyInfo.subsidiaries": "子公司管理",
  "companyInfo.addAddressAction": "+ 添加地址",
  "companyInfo.addContactAction": "+ 添加聯絡人",
  "companyInfo.businessLicense": "營業執照",
  "companyInfo.region": "所在地區",
  "companyInfo.mainlandChina": "大陸",
  "companyInfo.hongKongMacaoTaiwan": "港澳台",
  "companyInfo.uploadBusinessLicense": "上傳營業執照",
  "companyInfo.issuingAuthority": "發證機關",
  "companyInfo.enterText": "請輸入文字",
  "companyInfo.validityPeriod": "有效期",
  "companyInfo.selectStartDate": "選擇開始日期",
  "companyInfo.selectEndDate": "選擇結束日期",
  "companyInfo.basicInformation": "基本資料",
  "companyInfo.companyNameChinese": "公司中文名稱",
  "companyInfo.companyNameEnglish": "公司英文名稱",
  "companyInfo.shortName": "公司簡稱",
  "companyInfo.taxId": "公司税號",
  "companyInfo.supplierCode": "供應商編碼",
  "companyInfo.linkedCompany": "綁定公司",
  "companyInfo.setAsParentCompany": "設為主公司",
  "companyInfo.setAsSubsidiary": "設為子公司",
  "companyInfo.personInChargeLegalRepresentative": "負責人/法人",
  "companyInfo.companyPhone": "公司電話",
  "companyInfo.companyAddress": "公司地址",
  "companyInfo.companyLogo": "企業logo",
  "companyInfo.recommendedImageSize120120Px": "建議上傳 120 x 120 像素的圖片",
  "companyInfo.billingInformation": "財務開票資料",
  "companyInfo.invoiceDetails": "開票資料",
  "companyInfo.uploadStampedBankAndBillingDetails":
    "上傳開票資料（銀行資料蓋章版本）",
  "companyInfo.uploadInvoiceDetails": "上傳開票資料",
  "companyInfo.bankAccounts": "銀行賬號管理",
  "companyInfo.bankAccount": "銀行賬號",
  "companyInfo.addAction": "+ 增加",
  "companyInfo.delete": "刪除",
  "companyInfo.bankName": "開戶銀行",
  "companyInfo.bankBranch": "開戶支行",
  "companyInfo.bankShortName": "銀行簡稱",
  "companyInfo.setAsDefaultBank": "設為預設銀行",
  "companyInfo.defaultBank": "預設銀行",
  "companyInfo.bankRoutingNumber": "銀聯號",
  "companyInfo.paymentDetailsAttachment": "銀行付款資料附件",
  "companyInfo.uploadAttachment": "上傳附件",
  "companyInfo.additionalInformation": "補充資料",
  "companyInfo.companyType": "公司類型",
  "companyInfo.limitedLiabilityCompany": "有限責任公司",
  "companyInfo.jointStockCompany": "股份有限公司",
  "companyInfo.soleProprietorship": "個人獨資企業",
  "companyInfo.partnership": "合夥企業",
  "companyInfo.productCategories": "經營品類",
  "companyInfo.productCategory1": "經營品類一",
  "companyInfo.productCategory2": "經營品類二",
  "companyInfo.brand1": "經營品牌一",
  "companyInfo.brand2": "經營品牌二",
  "companyInfo.scope1": "範圍一",
  "companyInfo.scope2": "範圍二",
  "companyInfo.scope3": "範圍三",
  "companyInfo.category1": "品類一",
  "companyInfo.category2": "品類二",
  "companyInfo.category3": "品類三",
  "companyInfo.issuingAuthorityName": "發證機關名稱",
  "companyInfo.consumerElectronics": "消費電子",
  "companyInfo.industrialControl": "工業控制",
  "companyInfo.automotiveElectronics": "汽車電子",
  "companyInfo.energyControl": "能源控制",
  "companyInfo.smartSecurity": "智能安防",
  "companyInfo.applications": "應用領域",
  "companyInfo.applicationIndustryExamples":
    "例如 消費電子、工業控制、汽車電子、LED、能源控制、智能安防、家用電器等",
  "companyInfo.brands": "經營品牌",
  "companyInfo.businessScope": "經營範圍",
  "companyInfo.enterYourMainBusinessAreasThenPressEnterToAddEachOne":
    "請填寫主要經營範圍，點擊添加輸入字符，按回車確認",
  "companyInfo.add": "添加",
  "companyInfo.mainProducts": "主要產品",
  "companyInfo.enterYourMainProductsThenPressEnterToAddEachOne":
    "請填寫主要產品，點擊添加輸入字符，按回車確認",
  "companyInfo.companyIntroduction": "公司介紹",
  "companyInfo.certificates": "資歷證書",
  "companyInfo.honorsAndQualifications": "榮譽資質",
  "companyInfo.uploadOwnBrandAgencyBrandAndQualificationCertificates":
    "支持自主品牌證書、代理品牌證書、資質證書的上傳",
  "companyInfo.reset": "重置",
  "companyInfo.save": "儲存",
  "companyInfo.shippingAddress": "收貨地址",
  "companyInfo.default": "預設",
  "companyInfo.edit": "編輯",
  "companyInfo.shippingContacts": "收貨聯絡人",
  "companyInfo.setAsDefault": "設為預設",
  "companyInfo.chineseName": "中文名",
  "companyInfo.englishName": "英文名",
  "companyInfo.mobileNumber": "流動電話號碼",
  "companyInfo.wechat": "微信",
  "companyInfo.landline": "座機",
  "companyInfo.more": "更多",
  "companyInfo.actions": "操作",
  "companyInfo.companyName": "公司名稱",
  "companyInfo.legalRepresentative": "法人",
  "companyInfo.location": "所在地",
  "companyInfo.subsidiary": "子公司",
  "companyInfo.switch": "更換",
  "companyInfo.details": "詳情",
  "companyInfo.companyDetails": "企業資料詳情",
  "companyInfo.editCompanyDetails": "編輯企業資料",
  "companyInfo.file": "檔案",
  "companyInfo.setAsDefaultShippingAddress": "設為預設收貨地址",
  "companyInfo.uploadABusinessLicenseToRecognizeItsText":
    "上傳營業執照（自動識別營業執照文字資料）",
  "companyInfo.viewAttachment": "查看附件",
  "companyInfo.paymentDetails": "付款資料",
  "companyInfo.interbankRoutingNumber": "聯行號",
  "companyInfo.uploadAgain": "重新上傳",
  "companyInfo.recognizeImage": "圖片識別",
  "companyInfo.pasteAndRecognize": "粘貼並識別",
  "companyInfo.shippingAddressChinese": "收貨地址（中）",
  "companyInfo.shippingAddressEnglish": "收貨地址（英）",
  "companyInfo.recipient": "收貨人",
  "companyInfo.recipientPhone": "收貨電話",
  "companyInfo.contactChinese": "聯絡人（中）",
  "companyInfo.contactEnglish": "聯絡人（英）",
  "companyInfo.ms": "女士",
  "companyInfo.mr": "先生",
  "companyInfo.addButton": "+ 添加",
  "companyInfo.weChatNumber": "微信號碼",
  "companyInfo.linkCompany": "+ 添加關聯公司",
  "companyInfo.contactsHometown": "聯絡人籍貫",
  "companyInfo.personality": "聯絡人性格",
  "companyInfo.interests": "聯絡人愛好",
  "companyInfo.linkedNegotiator": "綁定談判人",
  "companyInfo.setAsDefaultContact": "設為預設聯絡人",
  "companyInfo.saveContact": "提交聯絡人資料",
  "companyInfo.addAddress": "添加地址",
  "companyInfo.editAddress": "編輯地址",
  "companyInfo.addContact": "添加聯絡人",
  "companyInfo.addEditContact": "添加/編輯聯絡人",
  "companyInfo.enterTheCompanyNameInChinese": "請輸入公司中文名稱",
  "companyInfo.enterTheCompanyNameInEnglish": "請輸入公司英文名稱",
  "companyInfo.enterAShortCompanyName": "請輸入公司簡稱",
  "companyInfo.enterTheTaxId": "請輸入公司税號",
  "companyInfo.enterTheSupplierCode": "請輸入供應商編碼",
  "companyInfo.searchForACompanyToLink": "搜索需要綁定的公司名稱",
  "companyInfo.enterAName": "請輸入姓名",
  "companyInfo.enterTheCompanyPhone": "請輸入公司電話",
  "companyInfo.enterTheCompanyAddress": "請輸入公司地址",
  "companyInfo.uploadCompanyLogo": "上傳企業logo",
  "companyInfo.enterTheBankName": "請輸入開戶銀行",
  "companyInfo.enterTheBankBranch": "請輸入開戶支行",
  "companyInfo.enterTheBankCode": "請輸入Bank Code",
  "companyInfo.enterAShortBankName": "請輸入銀行簡稱",
  "companyInfo.enterTheBankAccount": "請輸入銀行賬號",
  "companyInfo.enterTheBankRoutingNumber": "請輸入銀聯號",
  "companyInfo.enterTheSwiftCode": "請輸入Swift Code",
  "companyInfo.select": "請選擇",
  "companyInfo.enterAnApplication": "請輸入應用領域名稱",
  "companyInfo.uploadImage": "上傳圖片",
  "companyInfo.enterABrandName": "請輸入品牌名稱",
  "companyInfo.describeYourCompanyInUpTo500Characters":
    "請填寫公司介紹，500字以內",
  "companyInfo.certificateTitle": "證書標題",
  "companyInfo.uploadFile": "上傳檔案",
  "companyInfo.noShippingAddresses": "暫無收貨地址",
  "companyInfo.noContacts": "暫無聯絡人",
  "companyInfo.searchAddressRecipientOrPhone": "搜索地址、收貨人、電話號碼等",
  "companyInfo.noSubsidiaries": "暫無子公司",
  "companyInfo.pasteCompanyDetailsHereForAutomaticRecognitionAndFilling":
    "“粘貼識別”並輸入文本，智能識別公司資料資料並填充",
  "companyInfo.enterTheShippingAddressInChinese": "請填寫中文收貨地址",
  "companyInfo.enterTheShippingAddressInEnglish": "請填寫英文收貨地址",
  "companyInfo.enterTheRecipient": "請填寫收貨人",
  "companyInfo.enterTheRecipientPhone": "請填寫收貨電話",
  "companyInfo.enterTheContactNameInChinese": "請填寫聯絡人中文名稱",
  "companyInfo.enterTheContactNameInEnglish": "請填寫聯絡人英文名稱",
  "companyInfo.enterAMobileNumber": "請填寫流動電話號碼",
  "companyInfo.enterAWechatId": "請填寫微信號碼",
  "companyInfo.enterALandlineNumber": "請填寫座機",
  "companyInfo.enterTheLinkedCompany": "請填寫綁定公司",
  "companyInfo.enterTheContactsHometown": "請填寫聯絡人籍貫",
  "companyInfo.searchANegotiatorByPhone": "搜索需要綁定的談判人電話號碼",
  "companyInfo.bankPaymentDetailsUploaded": "銀行付款資料上傳成功",
  "companyInfo.savedSuccessfully": "儲存成功",
  "companyInfo.couldNotSave": "儲存失敗",
  "companyInfo.defaultContactUpdated": "預設聯絡人設置成功",
  "companyInfo.deleteThisContact": "確認刪除該聯絡人?",
  "companyInfo.deleteThisAddress": "確認刪除該地址?",
  "companyInfo.deleteThisCompany": "確認刪除該公司?",
  "companyInfo.deleteThisBankAccount": "確認刪除該銀行賬戶?",
  "companyInfo.confirm": "提示",
  "companyInfo.deletedSuccessfully": "刪除成功",
  "companyInfo.youCanAddMoreMobileNumbers":
    "可在流動電話號碼中繼續補充多個號碼",
  "companyInfo.youCanAddMoreWechatIds": "可在微信號碼中繼續補充多個微信",
  "companyInfo.linkACompany": "添加關聯公司",
  "companyInfo.cannotSaveContactCompanyIdIsMissing":
    "缺少企業ID，無法儲存聯絡人",
  "companyInfo.defaultShippingAddressUpdated": "預設收貨地址設置成功",
  "companyInfo.selectAnImageFile": "請選擇圖片檔案",
  "companyInfo.selectAnImageOrEnterTextFirst": "請先選擇圖片或輸入文本",
  "companyInfo.informationRecognized": "識別成功",
  "companyInfo.recognitionFailed": "識別失敗",
  "companyInfo.recognitionFailedPleaseTryAgain": "識別失敗，請重試",
  "companyInfo.cannotSaveAddressCompanyIdIsMissing": "缺少企業ID，無法儲存地址",
  "companyInfo.batchManagement": "批量管理",
  "companyInfo.newCompany": "新建公司",
  "companyInfo.switchLinkedCompany": "切換綁定公司",
  "companyInfo.editBankAccount": "編輯銀行賬戶",
  "companyInfo.addBankAccount": "添加銀行賬戶",
});

// 个人中心菜单
export const menu = Object.freeze({
  "personalMenu.outboundManagement": "出貨管理",
  "personalMenu.contractTranslation": "合同譯文審核",
  "personalMenu.contentTranslation": "動態譯文管理",
  "personalMenu.featuredTrading": "精選交易",
  "personalMenu.wallet": "我的錢包",
  "personalMenu.reportDashboard": "數據看板",
  "personalMenu.orders": "交易訂單",
  "personalMenu.goodsCenter": "商品中心",
  "personalMenu.goodsLibrary": "商品庫",
  "personalMenu.brands": "品牌管理",
  "personalMenu.suppliers": "供應商管理",
  "personalMenu.messages": "訊息管理",
  "personalMenu.supplyDemand": "供應需求",
  "personalMenu.postSupply": "供應發佈",
  "personalMenu.postDemand": "需求發佈",
  "personalMenu.quickSupply": "簡潔供應發佈",
  "personalMenu.quickDemand": "簡潔需求發佈",
  "personalMenu.bulkPost": "批量發佈",
  "personalMenu.customerManagement": "客戶管理",
  "personalMenu.myCustomers": "我的客戶",
  "personalMenu.myOrders": "我的訂單",
  "personalMenu.memberLevel": "會員等級",
  "personalMenu.levelList": "等級列表",
  "personalMenu.levelApplication": "等級申請",
  "personalMenu.levelBenefits": "等級權益",
  "personalMenu.memberIdentity": "會員身份",
  "personalMenu.identityList": "身份列表",
  "personalMenu.salesperson": "業務員",
  "personalMenu.customer": "客戶",
  "personalMenu.supplier": "供應商",
  "personalMenu.partner": "合作伙伴",
  "personalMenu.bidManagement": "競標管理",
  "personalMenu.bidReview": "競標審核",
  "personalMenu.bidList": "競標列表",
  "personalMenu.postBid": "發佈競標",
  "personalMenu.myBids": "我的競標",
  "personalMenu.myFollowers": "我的跟單員",
  "personalMenu.myFollowUps": "我的跟單",
  "personalMenu.favorites": "我的收藏",
  "personalMenu.wiki": "知識百科",
  "personalMenu.reviewManagement": "審核管理",
  "personalMenu.myPosts": "我的發佈",
  "personalMenu.myQuestions": "我的問答",
  "personalMenu.specifications": "規格書管理",
  "personalMenu.accountSettings": "賬號設置",
  "personalMenu.personalInfo": "個人資料",
  "personalMenu.companyInfo": "企業資料",
  "personalMenu.security": "安全設置",
  "personalMenu.verification": "賬號認證",
  "personalMenu.priceChannel": "價格頻道",
  "personalMenu.channelIdentity": "頻道身份",
  "personalMenu.messageCenter": "訊息中心",
  "personalMenu.watchlists": "行情自選",
  "personalMenu.certification": "企業認證",
  "personalMenu.submissions": "業務上報",
  "personalMenu.reviewQueue": "審核待辦",
  "personalMenu.reviewResults": "審查結果",
  "personalMenu.loading": "載入中...",
  "personalMenu.loadFailed": "載入失敗，請重試",
  "personalMenu.loginFirst": "請先登入",
});

// 桌面实名认证
export const desktopRealname = Object.freeze({
  "pcRealname.title": "實名認證",
  "pcRealname.back": "返回",
  "pcRealname.personalVerification": "個人認證",
  "pcRealname.submitIdentity": "提交身份認證資料",
  "pcRealname.identityInstructions":
    "請上傳本人有效身份證件，並確保填寫資料與證件一致。",
  "pcRealname.pending": "待認證",
  "pcRealname.documentMaterials": "證件材料",
  "pcRealname.fileRequirements": "支持 JPG、PNG 格式，單張圖片不超過 5MB",
  "pcRealname.bothSidesRequired": "兩面均需上傳",
  "pcRealname.portraitSide": "身份證人像面",
  "pcRealname.portraitDescription": "包含姓名、身份證號碼的一面",
  "pcRealname.uploadPortrait": "上傳人像面",
  "pcRealname.emblemSide": "身份證國徽面",
  "pcRealname.emblemDescription": "包含簽發機關、有效期限的一面",
  "pcRealname.uploadEmblem": "上傳國徽面",
  "pcRealname.basicInfo": "基本資料",
  "pcRealname.requiredHint": "帶 * 的字段為必填項，請核對無誤後提交",
  "pcRealname.fullName": "姓名",
  "pcRealname.namePlaceholder": "請輸入證件上的姓名",
  "pcRealname.idNumber": "身份證號",
  "pcRealname.idPlaceholder": "請輸入18位身份證號碼",
  "pcRealname.mobile": "流動電話號碼",
  "pcRealname.mobilePlaceholder": "請輸入本人流動電話號碼",
  "pcRealname.smsCode": "短訊驗證碼",
  "pcRealname.smsPlaceholder": "請輸入驗證碼",
  "pcRealname.getCode": "獲取驗證碼",
  "pcRealname.resendIn": "{count}秒後重新發送",
  "pcRealname.wechatId": "微信號",
  "pcRealname.wechatPlaceholder": "請輸入常用微信號",
  "pcRealname.sameMobile": "同流動電話號碼",
  "pcRealname.invalidName": "姓名不能為空、不能包含數字，且不能超過100個字符",
  "pcRealname.invalidId": "請輸入正確的身份證號",
  "pcRealname.mobileRequired": "請填寫流動電話號碼",
  "pcRealname.smsRequired": "請填寫短訊驗證碼",
  "pcRealname.privacyNotice":
    "認證資料僅用於身份核驗，平台將嚴格保護您的資料安全",
  "pcRealname.cancel": "取消",
  "pcRealname.submit": "提交認證",
  "pcRealname.process": "認證流程",
  "pcRealname.estimatedTime": "預計 1–2 分鐘",
  "pcRealname.uploadDocuments": "上傳證件",
  "pcRealname.uploadDocumentsHint": "提交身份證人像面與國徽面",
  "pcRealname.completeInformation": "填寫資料",
  "pcRealname.completeInformationHint": "補充本人身份及聯絡方式",
  "pcRealname.finishVerification": "完成核驗",
  "pcRealname.finishVerificationHint": "提交後完成實名認證",
  "pcRealname.photoRequirements": "拍攝要求",
  "pcRealname.photoCorners": "證件四角完整，不要裁切或遮擋",
  "pcRealname.photoClarity": "文字清晰可辨，避免反光與陰影",
  "pcRealname.photoValidity": "請上傳本人且在有效期內的證件",
  "pcRealname.invalidMobile": "請輸入正確的流動電話號碼",
  "pcRealname.smsSent": "短訊已發送,注意查收",
  "pcRealname.smsSendFailed": "發送失敗，請稍後重試",
  "pcRealname.completeRequired": "請完善必填資料",
  "pcRealname.wechatOrMobileRequired": "請填寫微信號或選中同流動電話號碼",
  "pcRealname.invalidSms": "請輸入正確的短訊驗證碼",
  "pcRealname.success": "認證成功!",
  "pcRealname.submitFailed": "提交失敗",
});

// 桌面钱包
export const desktopWallet = Object.freeze({
  "pcWallet.title": "我的錢包",
  "pcWallet.subtitle": "查看賬戶資產與交易獎勵記錄",
  "pcWallet.overview": "賬戶概覽",
  "pcWallet.overviewHint": "賬戶資金與權益資產",
  "pcWallet.balance": "賬戶餘額",
  "pcWallet.assets": "賬戶資產",
  "pcWallet.totalBalance": "當前賬戶總餘額",
  "pcWallet.withdraw": "去提現",
  "pcWallet.withdrawable": "可提現金額",
  "pcWallet.withdrawableHint": "可申請提現",
  "pcWallet.frozen": "凍結金額",
  "pcWallet.frozenHint": "待結算資金",
  "pcWallet.points": "積分",
  "pcWallet.pointsHint": "點擊查看積分明細",
  "pcWallet.coins": "金幣",
  "pcWallet.benefits": "賬戶權益",
  "pcWallet.pointsLedger": "積分明細",
  "pcWallet.pointsLedgerHint": "查看百科審核獎勵及積分收支記錄",
  "pcWallet.noPoints": "暫無積分明細",
  "pcWallet.changeDescription": "變動説明",
  "pcWallet.pointsChange": "積分變動",
  "pcWallet.pointsBalance": "積分餘額",
  "pcWallet.changedAt": "變動時間",
  "pcWallet.rewards": "獎勵明細",
  "pcWallet.rewardsHint": "交易成功獎勵及提現進度",
  "pcWallet.name": "名稱",
  "pcWallet.tradeReward": "交易成功獎勵",
  "pcWallet.tradeIdentity": "交易身份",
  "pcWallet.amount": "金額",
  "pcWallet.withdrawalProgress": "提現進度",
  "pcWallet.pending": "待到賬",
  "pcWallet.received": "已到賬",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "evaluation.result": "本次交易評價結果",
  "evaluation.instructions": "請按實際體驗完成評價，提交後無法修改",
  "evaluation.awaitingRating": "待評分",
  "evaluation.rateTarget": "對{target}的綜合評價",
  "supplier.fileCount": "共{count}份",
  "profile.myServices": "我的服務",
  "profile.myReviews": "我的評價",
  "profile.inProgress": "進行中",
  "profile.frequentFirst": "高頻詞1",
  "profile.frequentSecond": "高頻詞2",
  "account.confirmLogout": "確認登出目前帳戶嗎？",
  "evaluation.requestFailed": "請求失敗",
  "evaluation.succeeded": "評價成功",
  "evaluation.failed": "評價失敗",
  "supplier.taxNumber": "供應商稅號",
  "evaluation.description": "評價說明",
  "evaluation.overall": "綜合評價",
  "evaluation.negative": "負評",
  "evaluation.neutral": "中評",
  "evaluation.positive": "好評",
  "evaluation.categoryRatings": "分項評分",
  "evaluation.attitude": "服務態度",
  "evaluation.attitudeScore": "服務態度評分",
  "evaluation.service": "服務內容",
  "evaluation.serviceScore": "服務內容評分",
  "evaluation.response": "回應速度",
  "evaluation.responseScore": "回應速度評分",
  "evaluation.noRecipients": "暫無可評價的服務對象",
  "evaluation.submit": "提交評價",
  "evaluation.recipientCount": "位評價對象",
  "profile.sampleYears": "入駐x年",
  "profile.companyPlaceholder": "｜公司名稱",
  "profile.overallScore": "綜合分",
  "profile.sampleOrders": "26單",
  "profile.completedDeals": "已成交",
  "profile.positiveScore": "好評分",
});

// PC界面显示文案；不改动业务原值。
export const desktopWalletFollowup = Object.freeze({
  "pcWallet.noWithdrawals": "暫無提現明細",
  "pcWallet.totalCredit": "總額度：{amount}",
});

export const companyDialogs = Object.freeze({
  "companyDialogs.setDefaultBankFailed": "設定預設銀行失敗",
  "companyDialogs.addressIntro": "錄入或選擇買方收貨地址，用於採購訂單收貨資訊",
  "companyDialogs.recipientNameRequired": "請填寫收貨人姓名",
  "companyDialogs.noAddresses": "暫無地址可更換",
  "companyDialogs.dropImage": "請拖入圖片檔案",
  "companyDialogs.bankShortNameRequired": "請填寫銀行簡稱",
  "companyDialogs.accountInformation": "帳戶資訊",
  "companyDialogs.accountNameRequired": "請填寫帳戶名稱",
  "companyDialogs.accountAndCodes": "帳號與銀行代碼",
  "companyDialogs.defaultBankHint": "選擇銀行後將同步設為預設銀行",
  "companyDialogs.switchBankHint": "更換目前開戶銀行，確認後同步銀行資訊",
  "companyDialogs.noBanks": "暫無銀行",
  "companyDialogs.accountPrefix": "帳號：",
  "companyDialogs.switchBank": "更換銀行",
  "companyDialogs.noAlternativeBanks": "暫無可更換的銀行",
  "companyDialogs.confirmBankSwitch": "確認更換",
  "companyDialogs.companyNameZh": "公司名稱（中）",
  "companyDialogs.companyNameEn": "公司名稱（英）",
  "companyDialogs.bankNameZh": "銀行名稱（中）",
  "companyDialogs.bankNameEn": "銀行名稱（英）",
  "companyDialogs.companySearchFailed": "公司查詢失敗，請重試",
  "companyDialogs.companySearchPlaceholder": "輸入公司名稱查詢",
  "companyDialogs.companyCreateFailed": "新增公司失敗",
  "companyDialogs.bankSwitched": "銀行資訊已更換",
  "companyDialogs.createdBankRefresh":
    "銀行已建立，但未能識別新銀行，請重新整理公司資料後再次選擇",
  "companyDialogs.confirmDeleteSupplier":
    "確認刪除「{name}」嗎？刪除後無法復原。",
  "companyDialogs.contactCreated": "新增聯絡人成功",
  "companyDialogs.contactChanged": "更換聯絡人成功",
  "companyDialogs.defaultBankSet": "預設銀行設定成功",
  "companyDialogs.bankConfirmed": "銀行資訊已確認",
  "companyDialogs.addressCreated": "新增地址成功",
  "companyDialogs.addressChanged": "更換地址成功",
  "companyDialogs.confirmChangeAddress": "確認更換",
  "companyDialogs.newMainlandBank": "新增大陸銀行",
  "companyDialogs.newHongKongBank": "新增香港銀行",
  "companyDialogs.mainlandBankIntro": "補充大陸銀行帳戶資訊，用於採購訂單結算",
  "companyDialogs.hongKongBankIntro": "補充香港銀行帳戶資訊，用於採購訂單結算",
  "companyDialogs.bankEntityMissing": "目前銀行缺少實體ID，無法設為預設銀行",
  "companyDialogs.unnamedBank": "未命名銀行",
});

export const sharedFlowUi = Object.freeze({
  "companyDialogs.parentCompanyRequired": "設為子公司時必須綁定母公司",
  "companyDialogs.yearFiles": "{year} 年（{count}）",
  "companyDialogs.yearOption": "{year}年",
  "companyDialogs.monthOption": "{month}月",
  "companyDialogs.dayOption": "{day}日",
  "googleFeedback.unavailableLabel": "{label}無法使用：{error}",
  "googleFeedback.configurationUnavailable": "Google 登入設定暫時無法使用",
  "googleFeedback.initializationFailed": "Google 登入初始化失敗",
  "googleFeedback.unavailableRetry": "Google 登入暫時無法使用，請重試",
  "googleFeedback.verifyAccount": "請驗證已有平台帳號",
  "googleFeedback.reconnect": "Google 登入失敗，請重新連線",
});

// 钱包接口返回的固定来源与系统流水描述；不改写历史账本。
export const walletLedger = Object.freeze({
  "walletLedger.firstDatasheetDownload": "首次下載規格書",
  "walletLedger.repeatDatasheetDownload": "重複下載規格書",
  "walletLedger.datasheetDownload": "下載規格書",
  "walletLedger.datasheetDownloadCharge": "規格書下載扣除積分",
  "walletLedger.wikiReviewReward": "百科審核獎勵",
  "walletLedger.wikiReviewApprovedReward": "百科審核通過獎勵",
  "walletLedger.wikiPublishReward": "百科發佈獎勵",
  "walletLedger.wikiContentPublished": "百科內容審核通過並發佈",
  "walletLedger.wikiFavoriteReward": "百科收藏獎勵",
  "walletLedger.pointsTopUp": "積分充值",
  "walletLedger.pointsRefund": "積分退還",
  "walletLedger.pointsAdjustment": "積分調整",
  "walletLedger.adminAdjustment": "管理員調整積分",
  "walletLedger.systemGift": "系統贈送",
  "walletLedger.withdrawDebit": "提現發起扣減用戶正常餘額",
  "walletLedger.withdrawTotalIncrease": "提現發起新增累計提現金額",
  "walletLedger.withdrawRefund": "提現駁回退回用戶正常餘額",
  "walletLedger.withdrawTotalDecrease": "提現駁回減少累計提現金額",
  "walletLedger.creditRepayment": "信用額度還款",
  "walletLedger.balanceCreditRepayment": "餘額用於信用額度還款",
  "walletLedger.sellerReferrer": "賣方資訊提供人",
  "walletLedger.sellerNegotiator": "賣方談判人",
  "walletLedger.sellerBusiness": "賣方商務",
  "walletLedger.buyerReferrer": "買方資訊提供人",
  "walletLedger.buyerNegotiator": "買方談判人",
  "walletLedger.buyerBusiness": "買方商務",
  "walletLedger.supervisor": "監督人",
  "walletLedger.inspector": "驗貨人",
  "walletLedger.noBalanceRecords": "暫無餘額明細",
  "walletLedger.withDetail": "{reason}：{detail}",
  "walletLedger.creditUpgrade": "信用等級提升：L{before} -> L{after}",
});

export const messages = Object.freeze({
  ...walletLedger,
  ...sharedFlowUi,
  ...companyDialogs,
  ...desktopWalletFollowup,
  ...mobileWorkflow,
  ...base,
  ...settings,
  ...auth,
  ...mobileLogin,
  ...mobileRealname,
  ...mobileWallet,
  ...company,
  ...menu,
  ...desktopRealname,
  ...desktopWallet,
});
